import { Card, Col, Row, Space } from "antd";
import { isEmpty } from "lodash";
import { cloneElement } from "react";
import { usePermission } from "../../../hooks/usePermission";
import { DataTableSearch } from "./dataTableSeach";

export const DataTableLayout = ({
  searchDefaultValue,
  onSearchChange,
  renderFilters,
  children,
  searchable = true,
  actions = [],
  ...props
}) => {
  const { hasAccess } = usePermission();

  const actionsToShow = actions.filter(
    ({
      hide,
      permissions,
      invertPermission = false,
      allowSuperAdmin = true,
    }) => {
      if (hide) return false;
      if (permissions === undefined) return true;

      const hasPermission = hasAccess(permissions, allowSuperAdmin);

      return invertPermission ? !hasPermission : hasPermission;
    },
  );

  return (
    <Card bodyStyle={{ padding: 16 }} {...props}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Row gutter={[8, 8]}>
          <Col style={{ flex: 1 }}>
            <Row gutter={[8, 8]}>
              {searchable && (
                <Col style={{ width: 264 }}>
                  <DataTableSearch
                    defaultValue={searchDefaultValue}
                    onChange={(e) => onSearchChange(e.target.value || null)}
                  />
                </Col>
              )}
              {renderFilters?.()}
            </Row>
          </Col>

          {actionsToShow.map((a, i) => cloneElement(a.renderer(), { key: i }))}
        </Row>

        {children}
      </Space>
    </Card>
  );
};
